// NB: keep all env platform props from platform
import { BASE_URL as BASE_PLAT } from '@ublique/platform'

// if BASE_URL must be different in output section modify this one
export const BASE_URL = BASE_PLAT
